import { PALETTE } from './palette';

export const ALERT_COLORS = {
  SUCCESS: PALETTE.SUCCESS.LIGHTEST,
  ERROR: PALETTE.DANGER.LIGHTEST,
  NEUTRAL: PALETTE.PRIMARY.LIGHTER,
  WARNING: PALETTE.WARNING.LIGHTEST,
} as const;
